import React from 'react'
import { WorkorderContext, useWorkorderState } from '../../contexts'
import { InvoiceHome } from './InvoiceHome'

export const InvoiceRoot = () => {
    const workorderState = useWorkorderState()

    return (
        <WorkorderContext.Provider value={workorderState}>
            <InvoiceHome />
        </WorkorderContext.Provider>
    )
}
